const STATUS_STYLES = {
  "Received": "bg-slate-100 text-slate-700 border-slate-200",
  "Under Investigation": "bg-amber-50 text-amber-700 border-amber-200",
  "Waiting for Approval": "bg-orange-50 text-orange-700 border-orange-200",
  "Repair in Progress": "bg-lime-50 text-lime-700 border-lime-200",
  "Repaired": "bg-lime-50 text-lime-700 border-lime-200",
  "Replacement Approved": "bg-teal-50 text-teal-700 border-teal-200",
  "Replacement Dispatched": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Completed": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Warranty Rejected": "bg-red-50 text-red-700 border-red-200",
};

const STATUS_EMOJI = {
  "Received": "📋",
  "Under Investigation": "🔍",
  "Waiting for Approval": "⏳",
  "Repair in Progress": "🔧",
  "Repaired": "✅",
  "Replacement Approved": "🔄",
  "Replacement Dispatched": "📦",
  "Completed": "🎉",
  "Warranty Rejected": "❌",
};

export function StatusBadge({ status, className = "" }) {
  const style = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
  const emoji = STATUS_EMOJI[status] || "";
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap ${style} ${className}`}
      data-testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {emoji} {status}
    </span>
  );
}
